import React from 'react';
import styles from './styles.module.scss';

export const RequiredFieldTitle = ({ title }: { title: string }) => {
  const classes = [styles.RequiredFieldText, styles.AsteriskLeftMargin].join(
    ' ',
  );
  return (
    <label>
      <span className={styles.DrawerSubTitle}>{title}</span>
      <span className={classes}>*</span>
    </label>
  );
};
